export default __webpack_public_path__ + "static/media/RobotoCondensed-Italic.68043ac1.ttf";